var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_cof.js
// module id = 93
// module chunks = 168707334958949